import { render, staticRenderFns } from "./PlatformsSetUp.vue?vue&type=template&id=8ae27222&scoped=true"
import script from "./PlatformsSetUp.vue?vue&type=script&lang=js"
export * from "./PlatformsSetUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae27222",
  null
  
)

export default component.exports